import * as React from "react";
import { forwardRef } from "react";
const SvgGcpIam = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title === void 0 ? /* @__PURE__ */ React.createElement("title", { id: titleId }, "Icon_24px_IAM_Color") : title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { "data-name": "Product Icons" }, /* @__PURE__ */ React.createElement("path", { d: "M12 2 3.79 5.42v5.63c0 5.06 3.5 9.8 8.21 11 4.71-1.15 8.21-5.89 8.21-10.95V5.42Zm0 3.79a2.63 2.63 0 1 1-1.86.77A2.63 2.63 0 0 1 12 5.79m4.11 11.15A8.64 8.64 0 0 1 12 19.87a8.64 8.64 0 0 1-4.11-2.93v-2.25c0-1.67 2.74-2.52 4.11-2.52s4.11.85 4.11 2.52z", style: {
  fill: "#669df6",
  fillRule: "evenodd"
} }), /* @__PURE__ */ React.createElement("path", { d: "M12 2v3.79a2.63 2.63 0 1 1 0 5.26v1.12c1.37 0 4.11.85 4.11 2.52v2.25A8.64 8.64 0 0 1 12 19.87V22c4.71-1.15 8.21-5.89 8.21-10.95V5.42Z", style: {
  fillRule: "evenodd",
  fill: "#4285f4"
} })));
const ForwardRef = forwardRef(SvgGcpIam);
export default ForwardRef;
